export default __webpack_public_path__ + "static/media/buck_converter_digital.d20c42e6.svg";